import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-cream py-16 md:py-20" data-id="element-153">
      <div className="max-w-3xl mx-auto px-6" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-155">
          <p className="text-xl md:text-2xl italic text-gray-800 leading-relaxed" data-id="element-156">
            Estás a mitad de una frase en una videollamada importante. Tienes el
            concepto en la punta de la lengua, pero de repente, la palabra
            desaparece. Sientes ese vacío interno, el calor subiendo por tu
            cuello y la mirada de tus colegas esperando una respuesta que no
            llega.
          </p>

          <p className="text-xl md:text-2xl italic text-gray-800 leading-relaxed mt-6" data-id="element-157">
            No es que te estés volviendo "lenta". No es Alzheimer temprano. Es
            tu cerebro intentando funcionar con un combustible que ya no tiene,
            mientras el incendio de la inflamación hormonal bloquea tus
            recuerdos.
          </p>
        </motion.div>
      </div>
    </section>;
}